import { ChangeDetectionStrategy, Component, Input, OnChanges, TrackByFunction } from '@angular/core'
import { SiteSettings } from 'src/app/shared/models/site-settings.model'
import { FaqEntry } from '../types'
import * as jsonData from '../faq-data'
import { SiteIds } from 'src/app/shared/models/site.model'

@Component({
  selector: 'flo-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqSectionComponent implements OnChanges {
  @Input()
  header: string
  @Input()
  siteSettings: SiteSettings
  primaryParallaxImage1: string
  primaryParallaxImage2: string

  getPrimaryParallaxImage1(): string {
    if (this.siteSettings.site_id === SiteIds.VARSITY) {
      return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-1-blue.svg'
    }
    return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-1-red.svg'
  }

  getPrimaryParallaxImage2(): string {
    if (this.siteSettings.site_id === SiteIds.VARSITY) {
      return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-2-blue.svg'
    }
    return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-2-red.svg'
  }

  public faqData: FaqEntry[]

  trackByFAQ: TrackByFunction<string> = (index: number, faq: any) => {
    return faq.question
  }

  ngOnChanges() {
    this.faqData = jsonData.getFAQ(this.siteSettings.site_name, this.siteSettings.site_id)
    this.primaryParallaxImage1 = this.getPrimaryParallaxImage1()
    this.primaryParallaxImage2 = this.getPrimaryParallaxImage2()
  }

  constructor() {}
}
